import { useEffect, useState } from "react";
import {Formik} from "formik";
import {Button, Form} from "react-bootstrap";
import CategoriesApi from "../../api/CategoriesApi";
import Category from "../../model/Category";
import { FormattedMessage } from "react-intl";

type Props = {
    onSaveCategory: Function|undefined,
    categoryId: number|undefined
}

export default function CategoryForm({onSaveCategory, categoryId}: Props) {
    const [category, setCategory] = useState<Category>(new Category());

    const loadCategoryData = (categoryId:number) => {
        if (categoryId !== undefined) {
            CategoriesApi.getCategory(categoryId)
                .then(data => {
                    setCategory(data);
                })
        } 
    }

    useEffect(()=>{
        if (categoryId) {
            loadCategoryData(categoryId);
        }       
    }, [categoryId])

    const saveCategory = (values:Category) => {
        if (values.id) {
            return updateCategory(values);
        } else {
            return createCategory(values);
        }
    }

    const createCategory = (data: Category) => {
        return CategoriesApi.createCategory(data)
            .then((newCategory) => {
                if (onSaveCategory !== undefined) {
                    onSaveCategory(newCategory);
                }
            })
    }

    const updateCategory = (data:Category) => {
        return CategoriesApi.updateCategory(data)
            .then((savedCategory) => {
                if (onSaveCategory !== undefined) {
                    onSaveCategory(savedCategory);
                }
            })
    } 

    return (
        <>
            <Formik
                enableReinitialize={true}
                initialValues={category}
                validate={values => {
                    let errors = {
                        title: ""
                    };
                    let valid = true; 
                    if (!values.title) {
                        errors.title = 'Required';
                        valid = false;
                    }                    
                    return valid ? {} : errors;
                }}
                onSubmit={(values, { setSubmitting, resetForm }) => {
                    saveCategory(values).finally(() => {
                        setSubmitting(false);
                        resetForm();
                    })
                }}
            >
                {({
                      values,
                      errors,
                      touched,
                      handleChange,
                      handleBlur,
                      handleSubmit,
                      isSubmitting,
                      setFieldValue
                      /* and other goodies */
                  }) => {
                    return (
                        <Form onSubmit={handleSubmit} noValidate={true}>
                            <Form.Group controlId="title">
                                <Form.Control type="text" placeholder="Title"
                                              name="title"
                                              onChange={handleChange}
                                              onBlur={handleBlur}
                                              value={values.title}/>
                                {errors.title && touched.title && <Form.Text className="text-danger">
                                    {errors.title}
                                </Form.Text>}
                            </Form.Group>

                            <Button variant="primary" type="submit" disabled={isSubmitting} className="btn-color">
                                <FormattedMessage id="save"/>
                            </Button>
                        </Form>
                    )
                  }}
            </Formik>
        </>
    )
}